<template>
	<div
		@click="handleBlockClick"
		:class="{ 'is-loading': isLoading }"
		class="category-item"
	>
		<img
			:src="category.imageUrl"
			:alt="category.title"
			class="category-item__img img-responsive"
			loading="lazy"
		/>
		<div class="category-item__overlay">
			<h5
				v-html="category.title"
				class="category-item__title"
			></h5>
		</div>
	</div>
</template>


<script>
	import WpApi from '../helpers/WpApi.mjs'


	export default {
		name: 'CategoryBlock',
		props: {
			category: {
				type: Object,
				required: true
			}
		},

		data() {
			return {
				isLoading: false,
			}
		},

		methods: {
			async handleBlockClick() {

				// add loading animation
				this.isLoading = true

				// fetch products if no products are already in category
				if( !this.category.products.length ) {
					this.category.products = await WpApi.getCategoryProducts( this.category.id )
				}

				// signal to parent to change view
				this.$emit( 'handle_category_click' )

				// stop loading animation
				this.isLoading = false
			}
		},	
	}
</script>